import React, { Fragment, useState, useEffect } from "react";
import QueryService from "../../services/QueryService";
import { useHistory, useLocation } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
// Icon-based pagination assets (same as MessageTemplate/QueryResult)
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
import { makeStyles } from "@mui/styles";
import SaveModal from "../saveModal/SaveModal";
import CustomLoader from "../customLoader/CustomLoader";
import ErrorModal from "../errorDisplayModal/ErrorDisplayModal";
import Loader from "react-loader-spinner";
import SweetAlert from "react-bootstrap-sweetalert";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import "./QueryResult.css";

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--header": {
      fontSize: "14px",
    },
  },
});

const ShowAlert = ({ number, onCancel, onConfirm }) => (
  <SweetAlert
    warning
    showCancel
    showConfirm
    showCloseButton
    title={
      <p
        style={{ fontSize: "20px" }}
      >{`You have selected ${number} students!`}</p>
    }
    onConfirm={onConfirm}
    onCancel={onCancel}
    btnSize="sm"
  >
    Are you Sure ?
  </SweetAlert>
);

const QueryResultInternationalComponent = () => {
  let history = useHistory();
  let location = useLocation();
  console.log("location from the result", location);
  //const resultData = location?.state?.state;
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sortModel, setSortModel] = useState([]); // MUI DataGrid sort model
  const [pageSize, setPageSize] = useState(20);
  const [queryResultData, setQueryResultData] = useState();
  const [tableData, setTableData] = useState(0);
  //const [exportData, setExportData] = useState(location && location.state && location.state.state && location.state.state.export)
  //const [stuPag, setStuPag] = useState(location.state.state.stud_arr);
  //const [dataForAllSelected, setDataForAllSelected] = useState(exportData.shift())
  const [clickedStudent, setClickedStudent] = useState();
  const [openSaveModal, setOpenSaveModal] = useState(false);
  //const [saveQueryData, setSaveQuerydata] = useState(resultData ? resultData.shift() : '')
  const [duplicateQueryData, setDuplicateQueryData] = useState(
    location && location.state ? location.state.duplicateQueryData : ""
  );
  //const [payloadForSaveResult, setPayloadForSaveResult] = useState(location && location.state && location.state.queryResultData ? location.state.queryResultData : '')
  const [from, setFrom] = useState(location?.state?.fromSavedQueriedResult);
  const [paginationCount, setPaginationCount] = useState();
  const [inputValue, setInputValue] = useState("");
  const [selectedRowFromTable, setSelectedRowFromTable] = useState();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [selectedRowFromResultTable, setSelectedRowFromResultTable] = useState(
    []
  );
  const [saveSelection, setSaveSelection] = useState([]);
  const prevSelectionModel = React.useRef(selectedRowFromResultTable);
  const prevSelectionModelData = React.useRef(saveSelection);
  const [loaderForExport, setLoaderForExport] = useState(false);
  const [showGroupMessageAlert, setShowGroupMessageAlert] = useState(false);
  const [filteredSaveSelection, setFilteredSaveSelection] = useState([]);

  const [hideSaveResultButton, setHideSaveResultButton] = useState(
    location?.state?.from
  );

  const selectedAllData = location?.state?.state?.export.filter(
    (item) => item.hasOwnProperty("id") === true
  );

  // console.log(saveQueryData, from)
  const navigateToQuery = () => {
    localStorage.removeItem("query");
    history.push("/recruiter/campaign");
  };

  // Map DataGrid column field to backend sort field
  const sortFieldMap = {
    "0": "email",
    "1": "first_name",
    "2": "last_name",
    "3": "gender",
    "4": "usa_equivalent_gpa",
    "5": "actual_gpa",
    "6": "country",
    "7": "state",
    "8": "board_certification",
    "9": "current_school_name",
    "10": "english_test",
    "11": "planned_enrollment_date",
    "12": "desired_degree",
    "13": "project_work_seminar",
    "14": "social_leadership_activities",
    "15": "relevant_degree",
    "16": "gre_above_330",
    "17": "interests",
  };

  // useEffect(() => {
  //     if (openSaveModal === false) {
  //         location.state.openSaveModal = false
  //     }
  // }, [openSaveModal])

  const getPageData = (overrideSort) => {
    setLoading(true);
    let queryData = JSON.parse(localStorage.getItem("query"));
    if (queryData) {
      queryData.page = page;
      // attach server-side sort when requested
      const rule = overrideSort || (sortModel && sortModel[0]);
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          queryData.sort_by = rule.sort === "desc" ? "desc" : "asc";
          queryData.field = mapped;
        } else {
          // remove sort params if column isn't supported by backend
          delete queryData.sort_by;
          delete queryData.field;
        }
      } else {
        delete queryData.sort_by;
        delete queryData.field;
      }
    }

    QueryService.getInternationalResultPage(queryData)
      .then(async (data) => {
        console.log("data from the service", data.data);
        setQueryResultData(data.data);
        console.log(data.data.student_list);
        const newArrayOfObj = data.data.student_list.map(
          ({ 18: id, ...rest }) => ({
            id,
            ...rest,
          })
        );
        //console.log(newArrayOfObj);
        setTableData(newArrayOfObj);
        setPaginationCount(data.data.total_pages);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error from the service", error);
      });
  };

  const convertArrayToTable = async (apiArray, fileName) => {
    const tableRows = apiArray
      .map((obj) => [
        `<tr>
              ${Object.keys(obj)
                .map(
                  (key) =>
                    `<td>${
                      obj[key] === null || key === "id" || obj[key] === ""
                        ? ""
                        : obj[key]
                    }</td>`
                )
                .join("")}
           <tr/>`,
      ])
      .join("");
    const table = `<table>${tableRows}</table>`?.trim();
    const xmlTable = createXMLTable(table, fileName);
    const downloadURL = createFileUrl(xmlTable);
    downloadFile(downloadURL, fileName);
  };

  const createXMLTable = (table, fileName) => {
    const xmlTable = `
              <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40"
              >
                 <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
                 <head>
                    <xml>
                      <x:ExcelWorkbook>
                          <x:ExcelWorksheets>
                              <x:ExcelWorksheet>
                                  <x:Name>${fileName}</x:Name>
                                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                              </x:ExcelWorksheet>
                          </x:ExcelWorksheets>
                      </x:ExcelWorkbook>
                    </xml>
                 </head>
                 <body>
                   ${table}
                 </body>
              </html> `;
    return xmlTable;
  };

  const createFileUrl = (xmlTable) => {
    const tableBlob = new Blob([xmlTable], {
      type: "application/vnd.ms-excel;base64,",
    });
    const downloadURL = URL.createObjectURL(tableBlob);
    return downloadURL;
  };

  // useEffect(()=>{
  //     downloadFile(csvfile, "Test Download")
  // },[])

  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };

  const exportResult = () => {
    setLoaderForExport(true);
    let query = JSON.parse(localStorage.getItem("query"));
    // attach current sort in export payload
    if (query) {
      const rule = sortModel && sortModel[0];
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          query.sort_by = rule.sort === "desc" ? "desc" : "asc";
          query.field = mapped;
        } else {
          delete query.sort_by;
          delete query.field;
        }
      } else {
        delete query.sort_by;
        delete query.field;
      }
    }
    QueryService.exportResultInternational(query)
      .then((data) => {
        console.log("data from the service", data);
        downloadFile(data.data.download, "My File");
        setLoaderForExport(false);
      })
      .catch((error) => {
        setLoaderForExport(false);
        console.log("error from the service", error);
      });
  };
  useEffect(() => {
    if (!from) {
      getPageData();
    }
  }, [page]);

  useEffect(() => {
    if (from) {
      setTableData(selectedAllData);
    }
  }, []);

  const onCounselorContact = async (cell) => {
    history.push({
      pathname: "/recruiter/counselors",
      state: cell.row,
    });
  };

  const onStudentContact = async (cell) => {
    await setClickedStudent(cell.row);
    history.push( {
      pathname: "/recruiter/international-students",
      state: cell.row,
      openMessageModal: true,
      fromQueryResult: true,
    });
  };

  console.log(filteredSaveSelection);
  const onGroupMessage = () => {
    history.push( {
    pathname: '/recruiter/international-students',
    state: filteredSaveSelection,
    openMessageModal: true,
    fromQueryResult: true,
    payloadForSaveResult:queryResultData?.num_of_students,
    page:page,
})
}
  const columns = [
    // {
    //   field: "clickToContact",
    //   headerName: "Click to Contacts",
    //   headerClassName: "super-app-theme--header",
    //   minWidth: "200",
    //   renderCell: (cell) => {
    //     return (
    //       <div className="contact-button-container">
    //         <button
    //           onClick={() => onCounselorContact(cell)}
    //           className="contact-button"
    //         >
    //           <PersonIcon />
    //           Counselor
    //         </button>
    //         <button
    //           onClick={() => onStudentContact(cell)}
    //           className="contact-button"
    //         >
    //           <PersonIcon />
    //           Student
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "0",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      type: "string",
      //editable: true,
      minWidth: "300",
      resizable: true,
      sortable: true,
      //  flex:1
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "13px",
            color: "#1e40af",
            fontWeight: 500,
          }}
        >
          <span
            style={{
              backgroundColor: "#eff6ff",
              padding: "4px 8px",
              borderRadius: "6px",
              fontSize: "12px",
            }}
          >
            {params.value || "No email"}
          </span>
        </div>
      ),
    },
    {
      field: "1",
      headerName: "First name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      //minWidth: "150",
      resizable: true,
      sortable: true,
      //  flex:1
      renderCell: (params) => (
        <div
          style={{ fontWeight: 600, color: "#059669", fontSize: "14px" }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "2",
      headerName: "Last name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      // flex:1
      //minWidth:150
      renderCell: (params) => (
        <div
          style={{ fontWeight: 600, color: "#059669", fontSize: "14px" }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "3",
      headerName: "Gender",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      // flex:1
      //minWidth:150
      renderCell: (params) => (
        <div
          style={{
            backgroundColor:
              params.value === "Male"
                ? "#fef3f2"
                : params.value === "Female"
                ? "#f0f9ff"
                : "#f9fafb",
            color:
              params.value === "Male"
                ? "#dc2626"
                : params.value === "Female"
                ? "#2563eb"
                : "#6b7280",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {params.value || "Not specified"}
        </div>
      ),
    },
    {
      field: "4",
      headerName: "USA Equivalant GPA",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 200,
      //flex:1
      renderCell: (params) => {
        const val = parseFloat(params.value);
        const bg = isNaN(val)
          ? "#f9fafb"
          : val >= 3.5
          ? "#f0fdf4"
          : val >= 3.0
          ? "#fffbeb"
          : val >= 2.5
          ? "#fef2f2"
          : "#f9fafb";
        const color = isNaN(val)
          ? "#6b7280"
          : val >= 3.5
          ? "#059669"
          : val >= 3.0
          ? "#d97706"
          : val >= 2.5
          ? "#dc2626"
          : "#6b7280";
        return (
          <div
            style={{
              backgroundColor: bg,
              color,
              padding: "6px 10px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {isNaN(val) ? "N/A" : val.toFixed(2)}
          </div>
        );
      },
    },
    {
      field: "5",
      headerName: "Actual GPA",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const val = parseFloat(params.value);
        const bg = isNaN(val)
          ? "#f9fafb"
          : val >= 3.5
          ? "#f0fdf4"
          : val >= 3.0
          ? "#fffbeb"
          : val >= 2.5
          ? "#fef2f2"
          : "#f9fafb";
        const color = isNaN(val)
          ? "#6b7280"
          : val >= 3.5
          ? "#059669"
          : val >= 3.0
          ? "#d97706"
          : val >= 2.5
          ? "#dc2626"
          : "#6b7280";
        return (
          <div
            style={{
              backgroundColor: bg,
              color,
              padding: "6px 10px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            {isNaN(val) ? "N/A" : val.toFixed(2)}
          </div>
        );
      },
    },
    // {
    //   field: "6",
    //   headerName: "Current Grade",
    //   headerClassName: "super-app-theme--header",
    //   type: "string",
    //   editable: true,
    //   resizable: true,
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "6",
      headerName: "Country",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#f0f9ff",
            color: "#0369a1",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </span>
      ),
    },
    {
      field: "7",
      headerName: "State",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#f9fafb",
            color: "#374151",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            border: "1px solid #e5e7eb",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </span>
      ),
    },
    {
      field: "8",
      headerName: "Board Certification",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#eef2ff",
            color: "#4338ca",
            padding: "4px 8px",
            borderRadius: "10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {params.value || "N/A"}
        </span>
      ),
    },
    {
      field: "9",
      headerName: "Current School Name",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            fontSize: "13px",
            color: "#374151",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span
            style={{
              backgroundColor: "#f9fafb",
              padding: "4px 8px",
              borderRadius: "6px",
              border: "1px solid #e5e7eb",
            }}
          >
            {params.value || "No school specified"}
          </span>
        </div>
      ),
    },
    {
      field: "10",
      headerName: "English Test",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#fdf2f8",
            color: "#be185d",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </span>
      ),
    },
   
    // {
    //   field: "12",
    //   headerName: "Projection",
    //   headerClassName: "super-app-theme--header",
    //   type: "string",
    //   editable: true,
    //   resizable: true,
    //   minWidth: 200,
    //   flex: 1,
    // },
    {
      field: "11",
      headerName: "Planned Enrollment Date",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const text = params.value || "-";
        return (
          <span
            style={{
              backgroundColor: "#fff7ed",
              color: "#9a3412",
              padding: "4px 10px",
              borderRadius: "10px",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      field: "12",
      headerName: "Desired Degree",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      sortable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#ecfeff",
            color: "#0e7490",
            padding: "4px 8px",
            borderRadius: "10px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </span>
      ),
    },
    {
      field: "13",
      headerName: "Project Work Seminar",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const v = (params.value || "").toString().toLowerCase();
        const yes = v === "yes" || v === "true" || v === "1";
        return (
          <span
            style={{
              backgroundColor: yes ? "#f0fdf4" : "#fef2f2",
              color: yes ? "#059669" : "#dc2626",
              padding: "4px 8px",
              borderRadius: "10px",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            {yes ? "Yes" : params.value ? "No" : "N/A"}
          </span>
        );
      },
    },
    {
      field: "14",
      headerName: "Social Leadership Activities",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const items = Array.isArray(params.value)
          ? params.value
          : typeof params.value === "string"
          ? params.value.split(",")
          : [];
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            {items.length > 0 ? (
              items.slice(0, 3).map((t, idx) => (
                <span
                  key={idx}
                  style={{
                    backgroundColor: "#fef3f2",
                    color: "#dc2626",
                    padding: "2px 6px",
                    borderRadius: "8px",
                    fontSize: "11px",
                    fontWeight: 500,
                  }}
                >
                  {t?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: "#9ca3af", fontSize: "12px", fontStyle: "italic" }}>
                No activities
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "15",
      headerName: "Relevant Degree",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            backgroundColor: "#f3f4f6",
            color: "#374151",
            padding: "4px 8px",
            borderRadius: "10px",
            fontSize: "12px",
            fontWeight: 600,
            border: "1px solid #e5e7eb",
          }}
        >
          {params.value || "-"}
        </span>
      ),
    },
    {
      field: "16",
      headerName: "GRE Above 330",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const v = (params.value || "").toString().toLowerCase();
        const yes = v === "yes" || v === "true" || v === "1";
        return (
          <span
            style={{
              backgroundColor: yes ? "#ecfdf5" : "#fef2f2",
              color: yes ? "#047857" : "#b91c1c",
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {yes ? "Yes" : params.value ? "No" : "N/A"}
          </span>
        );
      },
    },
    {
      field: "17",
      headerName: "Interests",
      headerClassName: "super-app-theme--header",
      type: "string",
      editable: true,
      resizable: true,
      minWidth: 500,
      flex: 1,
      renderCell: (params) => {
        const items = Array.isArray(params.value)
          ? params.value
          : typeof params.value === "string"
          ? params.value.split(",")
          : [];
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            {items.length > 0 ? (
              items.slice(0, 4).map((interest, idx) => (
                <span
                  key={idx}
                  style={{
                    backgroundColor: "#fef7ff",
                    color: "#9333ea",
                    padding: "2px 6px",
                    borderRadius: "8px",
                    fontSize: "11px",
                    fontWeight: 500,
                  }}
                >
                  {interest?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: "#9ca3af", fontSize: "12px", fontStyle: "italic" }}>
                No interests
              </span>
            )}
          </div>
        );
      },
    },
  ];

  const saveResult = () => {
    console.log("clicked");
    setOpenSaveModal(true);
  };

  const cancel = () => {
    history.push("/recruiter/campaign");
  };

  const handleCellClick = (cell) => {
    let cel = cell.row;
    if (saveSelection && Array.isArray(saveSelection)) {
      console.log("inside if");
      let filteredValue = saveSelection.includes(cel);
      console.log("save selection", saveSelection, filteredValue);
      if (filteredValue === true) {
        let index = saveSelection.indexOf(cel);
        saveSelection.splice(index, 1);
        setSaveSelection(saveSelection);
        return;
      }
    } else if (
      saveSelection === "selected All" &&
      typeof saveSelection === "string"
    ) {
      const selectedRows = tableData.filter((item) =>
        selectedRowFromResultTable.includes(item.id)
      );
      let filteredValue = selectedRows.includes(cel);
      if (filteredValue === true) {
        let index = selectedRows.indexOf(cel);
        selectedRows.splice(index, 1);
        setSaveSelection(selectedRows);
        return;
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(saveSelection)) {
      const ids = saveSelection.map((o) => o.id);
      let filtered = saveSelection.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      setFilteredSaveSelection(filtered);
    } else if (typeof saveSelection === "string") {
      setFilteredSaveSelection("selected All");
    }
  }, [saveSelection]);

  console.log("saveSelection", saveSelection);
  const setPreviousSelection = () => {
    let prev = prevSelectionModel.current;
    setTimeout(() => {
      setSelectedRowFromResultTable(prev);
    });
  };
  const setPreviousSelectionData = () => {
    let prev = prevSelectionModelData.current;
    setTimeout(() => {
      setSaveSelection(prev);
    });
  };
  useEffect(() => {
    setPreviousSelection();
    setPreviousSelectionData();
  }, [page, tableData]);

  const onSelection = (ids) => {
    console.log("getting clled");
    if (Array.isArray(ids) && ids.length > 0) {
      setSelectedRowFromResultTable(ids);
      const selectedIDs = new Set(ids);
      let selectedRows = tableData.filter((item) => selectedIDs.has(item.id));
      // console.log('ids from the onSelection', ids, selectedRows, selectedRows.length)
      // let filteredValue = saveSelection.filter(item => selectedIDs.has(!item.id))
      // selectedRows = filteredValue
      if (page !== 1) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      } else if (page === 1 && selectedRows?.length === tableData.length) {
        setSelectAll(true);
        if (from) {
          setSaveSelection(selectedRows);
        } else if (!from) {
          setShowGroupMessageAlert(true);
          setSaveSelection("selected All");
        }
      } else if (page === 1 && selectedRows?.length !== tableData.length) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      }
    } else if (Array.isArray(ids) && ids.length === 0) {
      setSaveSelection([]);
      setSelectedRowFromResultTable([]);
      setFilteredSaveSelection([]);
    }
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
      <div className="query-result-container">
        <div className="inner-query-result-container">
          <div className="view-result container qr-header">
            <div>
              <button
                type="button"
                className="qr-back-btn"
                aria-label="Back"
                onClick={() => history.goBack()}
              >
                <img
                  src={require("../../assets/images/queryResult/back.png")}
                  alt="Back"
                  className="qr-back-img"
                />
              </button>
              <span className="qr-title-text" style={{ marginLeft: "10px" }}>Query Results</span>
              <span className="qr-title-divider"> | </span>
              <span className="qr-title-count">{`
                ${
                  queryResultData
                    ? queryResultData?.num_of_students
                    : from
                    ? tableData.length
                    : 0
                } Students Found`}</span>
            </div>
          </div>
          <div style={{ padding: "15px" }}>
            <p
              style={{ color: "#333333", opacity: "0.8" }}
              className="bold"
            >{`You are viewing ${
              tableData ? tableData?.length : 0
            } Student out of ${
              queryResultData ? queryResultData?.num_of_students : 0
            } Results`}</p>
          </div>
          {loading ? (
            <CustomLoader />
          ) : (
            <div
              className={
                paginationCount && paginationCount > 1
                  ? "table-container"
                  : "table-container-less"
              }
              style={{
                background: '#ffffff',
                borderRadius: '16px',
                padding: '16px',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                border: '1px solid #f1f5f9',
                margin: '16px 0',
              }}
            >
              <DataGrid
                className="result-table"
                pageSize={pageSize}
                rows={tableData}
                columns={columns}
                rowsPerPageOptions={[20]}
                checkboxSelection
                onSelectionModelChange={(ids) => onSelection(ids)}
                hideFooterPagination={!from ? true : false}
                hideFooterSelectedRowCount={false}
                rowHeight={145}
                columnHeader
                selectionModel={selectedRowFromResultTable}
                onRowClick={(row) => handleCellClick(row)}
                disableSelectionOnClick={true}
                autoPageSize={true}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={(model) => {
                  setSortModel(model);
                  // Reset to first page on new sort and refetch server data
                  const rule = model && model[0] ? model[0] : null;
                  if (!from) {
                    // ensure we call API with sort rule
                    // if page isn't 1 already, set then fetch in effect; else fetch now
                    if (page !== 1) {
                      setPage(1);
                      // also fetch immediately with override so UI is responsive
                      getPageData(rule);
                    } else {
                      getPageData(rule);
                    }
                  }
                }}
                sx={{
                  border: 'none',
                  '& .MuiDataGrid-cell': {
                    borderColor: '#f3f4f6',
                    fontSize: '13px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f8fafc',
                    '& .MuiDataGrid-columnHeader': {
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#374151',
                    },
                  },
                  '& .MuiDataGrid-row': {
                    '&:nth-of-type(even)': {
                      backgroundColor: '#fafafa',
                    },
                    '&:hover': {
                      backgroundColor: '#f3f4f6 !important',
                    },
                  },
                  '& .MuiDataGrid-cell:focus': {
                    outline: 'none !important',
                  },
                  '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: '#e0f2fe !important',
                    '&:hover': {
                      backgroundColor: '#b3e5fc !important',
                    },
                  },
                  '& .MuiDataGrid-virtualScroller': {
                    '&::-webkit-scrollbar': {
                      width: '6px',
                      height: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f5f9',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#87ceeb',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#5fb3d4',
                    },
                  }
                }}
              />
            </div>
          )}

          <div className="qr-footer-topline" />
          <div className="result-button-container">
            <button
              onClick={() =>
                saveSelection.length > 0 ? onGroupMessage() : ""
              }
              className="qr-footer-btn qr-footer-btn-secondary"
            >
              <img src={require("../../assets/images/queryResult/group.png")} alt="" className="btn-icon" />
              Group Message
            </button>
            <button
              onClick={
                from
                  ? () => convertArrayToTable(selectedAllData, "My File")
                  : () => exportResult()
              }
              style={{ justifyContent: "center" }}
              className="qr-footer-btn qr-footer-btn-secondary flex"
            >
              <img src={require("../../assets/images/queryResult/export.png")} alt="" className="btn-icon" />
              Export Results
              {loaderForExport && (
                <span>
                  <Loader
                    type="TailSpin"
                    color="#E36221"
                    height={20}
                    width={20}
                  />
                </span>
              )}
            </button>
            <button onClick={() => cancel()} className="qr-footer-btn qr-footer-btn-secondary">
              <img src={require("../../assets/images/queryResult/close.png")} alt="" className="btn-icon" />
              Cancel
            </button>
          </div>
          {(() => {
            const totalPages = from
              ? Math.ceil((tableData?.length || 0) / 20)
              : paginationCount || 0;
            return totalPages >= 1 ? (
              <div className="template-pagination-container">
                <div className="custom-pagination" style={{ marginLeft: "auto" }}>
                  <button
                    type="button"
                    aria-label="Previous"
                    className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                    onClick={() => {
                      if (page > 1) {
                        prevSelectionModel.current = selectedRowFromResultTable;
                        prevSelectionModelData.current = saveSelection;
                        setPage(page - 1);
                      }
                    }}
                  >
                    <img
                      src={page === 1 ? pageLeftHide : pageLeft}
                      alt="Prev"
                      className="pagination-img"
                    />
                  </button>
                  <div className="pagination-center">
                    <img src={pageCenter} alt="Page" className="pagination-img" />
                    <span className="pagination-number" style={{color:'white'}}>{page}</span>
                  </div>
                  <button
                    type="button"
                    aria-label="Next"
                    className={`pagination-btn ${page >= totalPages ? "disabled" : ""}`}
                    onClick={() => {
                      if (page < totalPages) {
                        prevSelectionModel.current = selectedRowFromResultTable;
                        prevSelectionModelData.current = saveSelection;
                        setPage(page + 1);
                      }
                    }}
                  >
                    <img src={pageRight} alt="Next" className="pagination-img" />
                  </button>
                </div>
              </div>
            ) : null;
          })()}
        </div>
      </div>
      {showGroupMessageAlert && (
        <ShowAlert
          number={queryResultData?.num_of_students}
          onConfirm={onGroupMessage}
          onCancel={() => {
            setShowGroupMessageAlert(false);
            setSaveSelection([]);
            setSelectedRowFromResultTable([]);
          }}
        />
      )}
      {openSaveModal && (
        <SaveModal
          openSaveModal={openSaveModal}
          setOpenSaveModal={setOpenSaveModal}
          //duplicateQueryData={duplicateQueryData}
          //saveQueryData={selectedAllData}
          inputValueForSave={inputValue}
          setInputValueForSave={setInputValue}
          openErrorModal={true}
          setOpenErrorModal={setOpenErrorModal}
          //saveFromSavedResult={from ? true : false}
          // payloadForSaveResult={payloadForSaveResult}
        />
      )}
      {/* {
                openErrorModal && <ErrorModal
                    openErrorModal={openErrorModal}
                    setOpenErrorModal={setOpenErrorModal}
                    text="Query"
                />
            } */}
   </div>
      </div>
    </Fragment>
  );
};
export default QueryResultInternationalComponent;
